/* Flavour counts describe the total across all selected packs. Legacy carts are converted only when edited. */
(() => {
  const flavours = {
    'copy-of-filled-crinkle-pack-3pc': ['Red Velvet', 'Butter Fudge', 'Cinnamon', 'Ube'],
    'silvanas-1': ['Cashew', 'Yema Polvoron', 'Ube', 'Biscoff', 'Buttercrunch', 'Pistachio ( NEW)'],
    'mixed-selection-signature-cupcakes-1': ['Strawberries and Cream', 'Mocha', 'Ube Leche flan', 'Ube cream', 'Ube Yema', 'Red velvet', 'Butter Fudge', 'Yema cheese', 'Buko Pandan', 'Biscoff', 'Chocolate Hazelnut']
  };
  const size = title => {
    const text = title.toLowerCase();
    if (/half.?dozen/.test(text)) return 6;
    if (/dozen/.test(text)) return 12;
    if (/three/.test(text)) return 3;
    if (/four/.test(text)) return 4;
    return Number(text.match(/\d+/)?.[0]) || 0;
  };
  const check = (values, limit) => {
    const numbers = values.map(value => value === '' ? 0 : Number(value));
    if (!limit) return { valid: false, total: 0, message: 'Please select a pack size.' };
    if (numbers.some(value => !Number.isSafeInteger(value) || value < 0)) return { valid: false, total: 0, message: 'Use whole numbers of 0 or more for each flavour.' };
    const total = numbers.reduce((sum, value) => sum + value, 0);
    return { total, valid: total === limit, message: total > limit ? `You’ve selected ${total} of ${limit} pieces. Remove ${total - limit} to complete your mix.` : total < limit ? `Choose ${limit - total} more to complete your selection.` : `All ${limit} pieces picked. Your mix is ready!` };
  };
  const product = document.querySelector('[data-hb-product]');
  if (product && flavours[product.dataset.productHandle]) {
    const form = product.querySelector('form');
    const select = form.querySelector('[data-variant-select]');
    const quantity = form.querySelector('[name=quantity]');
    const hidden = (name, value) => {
      const input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${name}]`; input.value = value; form.append(input); return input;
    };
    hidden('_hb_mix_scope', 'total');
    // Total-count mixes must not merge into another line with independent counts.
    const mixId = hidden('_hb_mix_id', crypto.randomUUID());
    const mixDescription = hidden('Flavour quantities', '');
    const panel = document.createElement('div');
    panel.className = 'hb-pack-status'; panel.id = 'Pack-status'; panel.tabIndex = -1; panel.setAttribute('role', 'status'); panel.setAttribute('aria-live', 'polite');
    form.querySelector('[data-personalisation-anchor]').before(panel);
    let choices;
    let adding = false;
    const inputs = () => {
      if (!choices && form.querySelector('.ap-options__number-container input[type=number]')) {
        choices = document.createElement('fieldset'); choices.className = 'hb-pack-choices';
        const legend = document.createElement('legend'); legend.textContent = 'Pick your flavour mix'; choices.append(legend);
        flavours[product.dataset.productHandle].forEach(name => {
          const label = document.createElement('label'); label.textContent = name;
          const input = document.createElement('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric'; input.value = '0'; input.name = `properties[${name}]`; label.append(input); choices.append(label);
        });
        panel.after(choices);
        const app = form.querySelector('#avpoptions-container__v2');
        if (app) { app.hidden = true; app.style.display = 'none'; }
      }
      return choices ? [...choices.querySelectorAll('input')] : [];
    };
    let attempted = false;
    let invalidPress = false;
    let interactionError = '';
    function refresh() {
      const fields = inputs();
      const perPack = size(select.selectedOptions[0]?.textContent || '');
      const count = Number(quantity.value);
      const limit = Number.isSafeInteger(count) && count > 0 ? perPack * count : 0;
      mixDescription.value = `Total across ${count} pack${count === 1 ? '' : 's'} (${limit} pieces)`;
      const result = fields.length ? check(fields.map(input => input.validity.badInput ? 'invalid' : input.value), limit) : { valid: false, total: 0, message: 'Loading flavour choices… Please wait before adding your box.' };
      fields.forEach(input => {
        input.min = '0'; input.step = '1';
        // Validate the combined count without letting the app silently clamp a flavour on blur.
        input.removeAttribute('max');
        const described = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean)); described.add(panel.id); input.setAttribute('aria-describedby', [...described].join(' '));
        input.setAttribute('aria-invalid', String(!input.validity.valid));
      });
      if (interactionError) { result.valid = false; result.message = interactionError; }
      const text = `${result.total} / ${limit || '—'} pieces selected. ${result.message} ${count} × ${perPack}-piece packs. Choose the flavour mix for all your packs combined.`;
      if (panel.textContent !== text) panel.textContent = text;
      panel.classList.toggle('is-complete', result.valid);
      panel.classList.toggle('is-error', attempted && !result.valid);
      return result;
    }
    function guard(event) {
      attempted = true;
      const wasInvalid = invalidPress; invalidPress = false;
      const result = refresh();
      if (wasInvalid && result.valid) { interactionError = 'Your choices refreshed. Check the flavour quantities, then enter your selection again.'; refresh(); }
      if (result.valid && !wasInvalid && quantity.checkValidity()) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (adding) return;
        adding = true; mixId.value = crypto.randomUUID();
        const button = form.querySelector('[name=add]'); button.disabled = true; panel.textContent = 'Adding your flavour mix…';
        const properties = Object.fromEntries(inputs().map((input, i) => [flavours[product.dataset.productHandle][i], String(Number(input.value || 0))]));
        Object.assign(properties, { _hb_mix_scope: 'total', _hb_mix_id: mixId.value, 'Flavour quantities': mixDescription.value });
        fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(select.value), quantity: Number(quantity.value), properties }] })
        }).then(async response => {
          if (!response.ok) throw new Error('Unable to add');
          if (window !== window.parent && typeof window.parent.hbDrawerCartAdded === 'function') window.parent.hbDrawerCartAdded(window);
          else location.assign(`${window.Shopify?.routes?.root || '/'}cart`);
        }).catch(() => {
          adding = false; button.disabled = false;
          panel.textContent = 'We couldn’t confirm this was added. Check your cart before retrying. Your flavour choices are still here.';
          panel.classList.add('is-error'); panel.focus();
        });
        return;
      }
      event.preventDefault(); event.stopImmediatePropagation();
      if (!form.querySelector('[name=quantity]').checkValidity()) form.querySelector('[name=quantity]').reportValidity();
      else { panel.focus(); panel.scrollIntoView({ block: 'center' }); }
    }
    document.addEventListener('pointerdown', event => { if (event.target.closest('[name=add]')?.closest('form') === form) invalidPress = !refresh().valid; }, true);
    document.addEventListener('click', event => { if (event.target.closest('[name=add]')?.closest('form') === form) guard(event); }, true);
    document.addEventListener('submit', event => { if (event.target === form) guard(event); }, true);
    form.addEventListener('input', () => { interactionError = ''; refresh(); }); form.addEventListener('change', refresh);
    new MutationObserver(refresh).observe(form, { childList: true, subtree: true });
    refresh();
  }
  const cart = document.querySelector('#cart');
  if (cart) {
    const editors = [];
    let saving = false;
    cart.querySelectorAll('[data-pack-handle]').forEach((line, index) => {
      const names = flavours[line.dataset.packHandle]; if (!names || line.dataset.optionParent) return;
      const raw = JSON.parse(line.dataset.packProperties || '{}') || {};
      const properties = Array.isArray(raw) ? Object.fromEntries(raw) : raw;
      // Chocolate Hazelnut silvanas were removed in October 2026; only lines that ordered some need a new mix.
      const retiredFlavours = line.dataset.packHandle === 'silvanas-1' ? Object.keys(properties).filter(name => /raf{1,2}aello/i.test(name) || (name === 'Chocolate Hazelnut' && Number(properties[name]) > 0)) : [];
      const needsReplacement = retiredFlavours.some(name => Number(properties[name]) > 0);
      const retiredNames = [...new Set(retiredFlavours.filter(name => Number(properties[name]) > 0).map(name => /raf{1,2}aello/i.test(name) ? 'Rafaello' : name))].join(' and ');
      const quantity = line.querySelector('[name="updates[]"]');
      const originalQuantity = Number(quantity.value);
      const perPack = size(line.dataset.packVariant);
      const details = document.createElement('details'); details.className = 'hb-pack-editor';
      const summary = document.createElement('summary'); summary.textContent = 'Edit your flavour mix';
      const help = document.createElement('p'); help.textContent = 'Choose the total flavour quantities across all packs in this item. Save your mix to update the cart total.';
      const grid = document.createElement('div'); grid.className = 'hb-pack-editor__grid';
      const status = document.createElement('p'); status.id = `Cart-pack-status-${index}`; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.tabIndex = -1;
      const fields = names.map(name => {
        const label = document.createElement('label'); label.textContent = name;
        const input = document.createElement('input'); input.type = 'number'; input.min = '0'; input.step = '1'; input.inputMode = 'numeric';
        input.value = String(Number(properties[name] || 0) * (properties._hb_mix_scope === 'total' ? 1 : originalQuantity));
        input.setAttribute('aria-describedby', status.id); label.append(input); grid.append(label); return input;
      });
      const save = document.createElement('button'); save.type = 'button'; save.className = 'button button--secondary'; save.textContent = 'Save flavour mix';
      details.append(summary, help, grid, status, save); line.append(details);
      const originalValues = fields.map(input => input.value).join('|');
      let busy = false;
      const dirty = () => retiredFlavours.length > 0 || Number(quantity.value) !== originalQuantity || fields.map(input => input.value).join('|') !== originalValues;
      const validate = () => {
        const count = Number(quantity.value);
        const validQuantity = quantity.checkValidity() && Number.isSafeInteger(count) && count > 0;
        const result = check(fields.map(input => input.validity.badInput ? 'invalid' : input.value), validQuantity ? perPack * count : 0);
        status.textContent = validQuantity ? `${result.total} / ${perPack * count} pieces selected for ${count} pack${count === 1 ? '' : 's'}. ${result.message}` : 'Choose a whole number of packs, at least 1.';
        if (needsReplacement) status.textContent = `${retiredNames} ${retiredNames.includes(' and ') ? 'are' : 'is'} no longer available. Choose replacement flavours and save your mix. ` + status.textContent;
        if (dirty()) status.textContent += ' Save your flavour mix before continuing.';
        details.classList.toggle('is-error', !result.valid); save.disabled = busy || !result.valid || !validQuantity;
        line.dataset.packDirty = String(dirty() || busy);
        return result.valid && validQuantity;
      };
      const focus = () => { details.open = true; status.focus(); status.scrollIntoView({ block: 'center' }); };
      const payload = () => {
        const count = Number(quantity.value);
        const nextProperties = { ...properties, _hb_mix_scope: 'total', _hb_mix_id: properties._hb_mix_id || crypto.randomUUID(), 'Flavour quantities': `Total across ${count} pack${count === 1 ? '' : 's'} (${perPack * count} pieces)` };
        retiredFlavours.forEach(name => { delete nextProperties[name]; });
        names.forEach((name, i) => { nextProperties[name] = String(Number(fields[i].value || 0)); });
        return { id: line.dataset.lineKey, quantity: count, properties: nextProperties, previousProperties: properties };
      };
      const editor = { validate, dirty: () => dirty() || busy, focus, payload };
      editors.push(editor);
      line.dataset.packEditor = 'true';
      quantity.addEventListener('input', () => { details.open = true; validate(); });
      quantity.addEventListener('change', () => { details.open = true; validate(); });
      grid.addEventListener('input', validate);
      save.addEventListener('click', async () => {
        if (saving) return;
        const invalid = editors.find(item => !item.validate());
        if (invalid) { invalid.focus(); return; }
        const pending = editors.filter(item => item.dirty() || item === editor).map(item => item.payload());
        saving = true; busy = true; validate(); save.textContent = 'Saving…';
        // Prevent a pending native quantity update racing with the flavour writes.
        cart.dataset.packSaving = 'true';
        cart.setAttribute('aria-busy', 'true');
        const locked = [...cart.querySelectorAll('input[name="updates[]"], .hb-pack-editor input, .hb-pack-editor button, [data-cart-step]')].map(control => [control, control.disabled]);
        locked.forEach(([control]) => { control.disabled = true; });
        try {
          const updates = Object.fromEntries([...cart.querySelectorAll('[data-line-key]:not([data-pack-editor])')].map(item => [item.dataset.lineKey, Number(item.querySelector('[name="updates[]"]').value)]));
          if (!Object.values(updates).every(value => Number.isSafeInteger(value) && value >= 0)) throw new Error('Invalid quantity');
          const note = cart.querySelector('[name=note]')?.value || '';
          const ordinary = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates, note }) });
          if (!ordinary.ok) throw new Error('Unable to save');
          let latestCart = await ordinary.json();
          const sameProperties = (a, b) => {
            const left = a || {}; const right = b || {};
            return Object.keys(left).length === Object.keys(right).length && Object.keys(left).every(key => String(left[key]) === String(right[key]));
          };
          for (const payload of pending) {
            const matches = latestCart.items.filter(item => String(item.variant_id) === payload.id.split(':')[0] && sameProperties(item.properties, payload.previousProperties));
            const current = matches.find(item => item.key === payload.id) || (matches.length === 1 ? matches[0] : null);
            if (!current) throw new Error('Cart changed; refresh before retrying');
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
              method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: current.key, quantity: payload.quantity, properties: payload.properties })
            });
            if (!response.ok) throw new Error('Unable to save');
            latestCart = await response.json();
          }
          // Reload server-rendered prices and reset pickup confirmation after the change.
          if (window !== window.parent && typeof window.parent.hbDrawerCartAdded === 'function') window.parent.hbDrawerCartAdded(window);
          else location.reload();
        } catch {
          locked.forEach(([control, disabled]) => { control.disabled = disabled; });
          cart.removeAttribute('aria-busy');
          saving = false; busy = false; delete cart.dataset.packSaving; validate(); save.textContent = 'Retry saving mix';
          status.textContent = 'We couldn’t confirm your update. Refresh to check your cart, or retry saving your mix. Your choices are still shown here.'; focus();
        }
      });
      if (!validate() || needsReplacement) details.open = true;
    });
    const guard = event => {
      const invalid = editors.find(editor => saving || !editor.validate() || editor.dirty());
      if (!invalid) return;
      event.preventDefault(); event.stopImmediatePropagation(); invalid.focus();
    };
    document.addEventListener('click', event => { if (event.target.closest('[name=checkout], [name=update]')) guard(event); }, true);
    document.addEventListener('submit', event => { if (event.target === cart) guard(event); }, true);
  }
})();
